import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, Image, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Text } from '@abb/uikit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EDIRECTION_PAGE } from './enum';
export function CampaignDetailModal(param) {
    let { isOpen, onClose, campaign } = param;
    const { t } = useTranslation('common');
    if (!campaign) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Modal, {
        isCentered: true,
        size: "lg",
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ _jsx(ModalOverlay, {}),
            /*#__PURE__*/ _jsxs(ModalContent, {
                borderRadius: "6px",
                containerProps: {
                    px: 2
                },
                children: [
                    /*#__PURE__*/ _jsx(ModalHeader, {
                        p: "0",
                        children: /*#__PURE__*/ _jsx(Image, {
                            borderTopRadius: "6px",
                            width: '100%',
                            src: 'data:;base64,' + campaign.imageFile
                        })
                    }),
                    /*#__PURE__*/ _jsxs(ModalBody, {
                        p: "20px",
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                fontSize: "20px",
                                fontWeight: 600,
                                children: campaign.title
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                children: campaign.content
                            }),
                            /*#__PURE__*/ _jsxs(Flex, {
                                justifyContent: "flex-end",
                                p: "20px 4px 0",
                                children: [
                                    /*#__PURE__*/ _jsx(Button, {
                                        onClick: onClose,
                                        mr: "16px",
                                        variant: "gray",
                                        children: t('actions.close')
                                    }),
                                    /*#__PURE__*/ _jsx(Button, {
                                        onClick: ()=>{
                                            window.open(!!campaign.redirectionUrl ? campaign.redirectionUrl : EDIRECTION_PAGE[campaign.redirectionPage], '_blank');
                                            onClose();
                                        },
                                        children: t('campaigns.detail')
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
